import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import {
  ArrowRight,
  BookOpen,
  List,
  Scissors,
  Scale,
  Percent,
  Leaf,
  Fish,
  Beef,
  Shell,
  Apple,
  Flame,
  Lightbulb,
  Calculator,
  AlertTriangle,
} from 'lucide-react';

/* ─── Data: Verduras y Hortalizas ────────────────────── */

const mermasVerduras = [
  ['Patata', '15%', '5%', '20%', '1,25'],
  ['Cebolla', '10%', '3%', '13%', '1,15'],
  ['Zanahoria', '18%', '5%', '23%', '1,30'],
  ['Pimiento rojo', '18%', '3%', '21%', '1,27'],
  ['Pimiento verde', '15%', '3%', '18%', '1,22'],
  ['Tomate', '5%', '8%', '13%', '1,15'],
  ['Lechuga', '25%', '0%', '25%', '1,33'],
  ['Espinaca', '20%', '15%', '35%', '1,54'],
  ['Calabacin', '8%', '10%', '18%', '1,22'],
  ['Berenjena', '10%', '12%', '22%', '1,28'],
  ['Brocoli', '35%', '5%', '40%', '1,67'],
  ['Coliflor', '40%', '5%', '45%', '1,82'],
  ['Judia verde', '10%', '5%', '15%', '1,18'],
  ['Puerro', '35%', '5%', '40%', '1,67'],
  ['Apio', '30%', '3%', '33%', '1,49'],
  ['Champinon', '5%', '8%', '13%', '1,15'],
  ['Esparrago verde', '35%', '8%', '43%', '1,75'],
  ['Esparrago blanco', '40%', '5%', '45%', '1,82'],
  ['Alcachofa', '55%', '5%', '60%', '2,50'],
  ['Guisante (con vaina)', '55%', '3%', '58%', '2,38'],
  ['Habas (con vaina)', '60%', '3%', '63%', '2,70'],
  ['Remolacha', '20%', '5%', '25%', '1,33'],
  ['Nabo', '18%', '5%', '23%', '1,30'],
  ['Col lombarda', '20%', '8%', '28%', '1,39'],
];

/* ─── Data: Frutas ───────────────────────────────────── */

const mermasFrutas = [
  ['Manzana', '10%', '8%', '18%', '1,22'],
  ['Naranja', '35%', '0%', '35%', '1,54'],
  ['Platano', '35%', '0%', '35%', '1,54'],
  ['Fresa', '8%', '0%', '8%', '1,09'],
  ['Melon', '35%', '0%', '35%', '1,54'],
  ['Sandia', '40%', '0%', '40%', '1,67'],
  ['Pina', '45%', '0%', '45%', '1,82'],
  ['Mango', '30%', '0%', '30%', '1,43'],
  ['Kiwi', '15%', '0%', '15%', '1,18'],
  ['Limon', '40%', '0%', '40%', '1,67'],
  ['Melocoton', '15%', '5%', '20%', '1,25'],
  ['Uva', '5%', '0%', '5%', '1,05'],
  ['Pera', '12%', '8%', '20%', '1,25'],
  ['Aguacate', '30%', '0%', '30%', '1,43'],
  ['Granada', '45%', '0%', '45%', '1,82'],
  ['Papaya', '30%', '0%', '30%', '1,43'],
];

/* ─── Data: Carnes ───────────────────────────────────── */

const mermasCarnes = [
  ['Ternera — lomo', '8%', '15%', '23%', '1,30'],
  ['Ternera — entrecot', '5%', '12%', '17%', '1,20'],
  ['Ternera — solomillo', '10%', '18%', '28%', '1,39'],
  ['Cerdo — lomo', '5%', '15%', '20%', '1,25'],
  ['Cerdo — costilla', '15%', '10%', '25%', '1,33'],
  ['Cerdo — panceta', '5%', '20%', '25%', '1,33'],
  ['Pollo entero', '25%', '15%', '40%', '1,67'],
  ['Pechuga de pollo', '5%', '15%', '20%', '1,25'],
  ['Muslo de pollo', '15%', '12%', '27%', '1,37'],
  ['Cordero — pierna', '20%', '15%', '35%', '1,54'],
  ['Cordero — paletilla', '22%', '15%', '37%', '1,59'],
  ['Conejo entero', '30%', '15%', '45%', '1,82'],
  ['Pato (magret)', '10%', '20%', '30%', '1,43'],
  ['Codorniz', '20%', '15%', '35%', '1,54'],
];

/* ─── Data: Pescados ─────────────────────────────────── */

const mermasPescados = [
  ['Merluza entera', '45%', '10%', '55%', '2,22'],
  ['Lubina entera', '40%', '10%', '50%', '2,00'],
  ['Dorada entera', '42%', '10%', '52%', '2,08'],
  ['Salmon (lomo)', '5%', '15%', '20%', '1,25'],
  ['Bacalao fresco entero', '40%', '10%', '50%', '2,00'],
  ['Bacalao desalado (lomo)', '5%', '8%', '13%', '1,15'],
  ['Rape entero (con cabeza)', '55%', '10%', '65%', '2,86'],
  ['Rodaballo entero', '50%', '10%', '60%', '2,50'],
  ['Lenguado entero', '50%', '10%', '60%', '2,50'],
  ['Atun (lomo limpio)', '5%', '12%', '17%', '1,20'],
  ['Sardina', '30%', '8%', '38%', '1,61'],
  ['Boqueron', '28%', '5%', '33%', '1,49'],
  ['Pulpo', '5%', '30%', '35%', '1,54'],
  ['Calamar', '20%', '10%', '30%', '1,43'],
  ['Trucha entera', '35%', '10%', '45%', '1,82'],
  ['Pez espada (rodaja)', '8%', '12%', '20%', '1,25'],
];

/* ─── Data: Mariscos ─────────────────────────────────── */

const mermasMariscos = [
  ['Gamba roja', '35%', '5%', '40%', '1,67'],
  ['Langostino', '30%', '5%', '35%', '1,54'],
  ['Cigala', '55%', '5%', '60%', '2,50'],
  ['Bogavante', '50%', '5%', '55%', '2,22'],
  ['Mejillon', '60%', '5%', '65%', '2,86'],
  ['Almeja', '55%', '3%', '58%', '2,38'],
  ['Vieira', '60%', '5%', '65%', '2,86'],
  ['Percebe', '50%', '0%', '50%', '2,00'],
  ['Necora', '55%', '0%', '55%', '2,22'],
  ['Cangrejo de rio', '65%', '0%', '65%', '2,86'],
];

/* ─── Data: Mermas por coccion ───────────────────────── */

const mermasCoccion = [
  ['Cruda (sin coccion)', '0%', 'Tartares, ceviches, ensaladas'],
  ['Hervida / cocida', '10-20%', 'Verduras, pastas, legumbres, mariscos'],
  ['Al vapor', '8-15%', 'Pescados, verduras — menor perdida que hervido'],
  ['Asada / horno', '15-25%', 'Carnes, aves, tubérculos — pierde grasa y agua'],
  ['A la plancha', '12-20%', 'Pescados, carnes — perdida variable segun grasa'],
  ['Frita / fritura', '5-15%', 'Absorbe aceite pero pierde agua — menor perdida neta'],
  ['Confitada', '5-10%', 'Coccion lenta en grasa — minima perdida de peso'],
  ['Braseada / estofada', '20-35%', 'Cocciones largas de carnes duras — alta perdida'],
  ['A la parrilla / brasa', '18-28%', 'Similar al horno pero con mas evaporacion'],
  ['Sous vide', '3-8%', 'Minima perdida al cocinar en vacio'],
];

/* ─── FAQs ───────────────────────────────────────────── */

const faqs = [
  {
    q: '¿Que es la merma de un alimento?',
    a: 'La merma es el porcentaje de peso que se pierde al manipular un ingrediente desde su estado bruto (tal como lo recibes del proveedor) hasta que esta listo para servir. Incluye dos fases: la merma de limpieza (pelado, deshuesado, despinado, retirada de partes no comestibles) y la merma de coccion (perdida de agua, grasa y volumen durante el proceso termico). Un ingrediente con un 40% de merma total significa que de cada kilo comprado solo aprovechas 600 gramos.',
  },
  {
    q: '¿Como calculo la merma real de mis ingredientes?',
    a: 'El metodo mas fiable es el pesaje directo: 1) Pesa el ingrediente en bruto (peso de compra). 2) Limpialo como lo haras normalmente (pela, deshuesa, retira partes no comestibles). 3) Pesa de nuevo (peso limpio). 4) Cocinalo. 5) Pesa una ultima vez (peso cocinado). La merma de limpieza es: (Peso bruto - Peso limpio) / Peso bruto x 100. La merma total es: (Peso bruto - Peso cocinado) / Peso bruto x 100. Repite al menos 3-5 veces para obtener una media fiable.',
  },
  {
    q: '¿Que es el factor de rendimiento?',
    a: 'El factor de rendimiento es el multiplicador que necesitas aplicar al peso neto deseado para saber cuanto producto bruto debes comprar. Se calcula como: Factor = 1 / (1 - Merma%). Por ejemplo, si la alcachofa tiene un 60% de merma total, el factor de rendimiento es 1 / (1 - 0,60) = 2,50. Esto significa que para obtener 1 kg de alcachofa limpia y cocinada, necesitas comprar 2,5 kg de alcachofas brutas.',
  },
  {
    q: '¿Las mermas de esta tabla son exactas para mi cocina?',
    a: 'No, son valores orientativos basados en promedios de cocina profesional espanola. Las mermas reales varian segun la calidad del producto, el proveedor, la temporada, el tamano de las piezas y la habilidad del equipo de cocina. Usa esta tabla como punto de partida y ajusta los porcentajes con tus propias mediciones. Con el tiempo, tendras mermas personalizadas mucho mas precisas.',
  },
  {
    q: '¿Como afecta la merma al precio real de un ingrediente?',
    a: 'La merma multiplica el precio efectivo de un ingrediente. La formula es: Precio real = Precio compra / (1 - Merma%). Por ejemplo, si compras rape entero a 18 euros/kg y tiene un 65% de merma total, el precio real del rape aprovechable es: 18 / (1 - 0,65) = 51,43 euros/kg. Esa es la diferencia entre comprar rape entero o comprarlo ya limpio en lomos: el proveedor ya ha aplicado la merma al precio.',
  },
  {
    q: '¿Las mermas de coccion se suman a las de limpieza?',
    a: 'Si, se aplican de forma secuencial. Primero se pierde peso en la limpieza (pelado, deshuesado, etc.) y despues se pierde mas peso durante la coccion (agua, grasa). La merma total es la combinacion de ambas. En esta tabla mostramos las tres columnas separadas para que puedas ver cuanto pierdes en cada fase y tomar decisiones como: comprar el ingrediente ya limpio (ahorrando merma de limpieza pero pagando mas) o limpiarlo tu (merma alta pero precio de compra menor).',
  },
  {
    q: '¿Cual es el ingrediente con mas merma en una cocina profesional?',
    a: 'Los ingredientes con mayor merma total suelen ser: alcachofa (60%), cangrejo de rio (65%), mejillon (65%), vieira (65%), rape entero con cabeza (65%), habas con vaina (63%), y guisantes con vaina (58%). Estos ingredientes necesitan un factor de rendimiento de 2,5 a 2,86, lo que significa que debes comprar entre 2,5 y 2,86 veces mas producto bruto del que vas a servir. Ignorar estas mermas es una de las principales causas de food cost descontrolado.',
  },
  {
    q: '¿Debo aplicar merma a ingredientes secos (especias, harinas, arroz)?',
    a: 'Los ingredientes secos (especias, sal, azucar, harina, arroz, pasta seca) tienen merma de limpieza practicamente nula (0%). Sin embargo, algunos ganan peso en coccion (el arroz absorbe agua y triplica su peso, la pasta duplica). En estos casos la "merma" es negativa — ganas peso. Para el escandallo, lo habitual es calcular el coste sobre el peso seco (el que compras) y no aplicar merma. El peso de coccion solo importa para calcular gramajes de emplatado.',
  },
];

/* ─── Table of Contents ──────────────────────────────── */

const toc = [
  { id: 'que-es-merma', label: 'Que es la merma y por que afecta a tus costes' },
  { id: 'como-usar-tabla', label: 'Como usar esta tabla de mermas' },
  { id: 'mermas-verduras', label: 'Tabla: Mermas de verduras y hortalizas' },
  { id: 'mermas-frutas', label: 'Tabla: Mermas de frutas' },
  { id: 'mermas-carnes', label: 'Tabla: Mermas de carnes' },
  { id: 'mermas-pescados', label: 'Tabla: Mermas de pescados' },
  { id: 'mermas-mariscos', label: 'Tabla: Mermas de mariscos' },
  { id: 'precio-real-merma', label: 'Calcular el precio real con merma' },
  { id: 'mermas-coccion', label: 'Mermas por tipo de coccion' },
  { id: 'reducir-mermas', label: 'Como reducir mermas en tu cocina' },
  { id: 'software-vs-excel', label: 'Software vs Excel para controlar mermas' },
  { id: 'faqs', label: 'Preguntas frecuentes' },
];

/* ─── Schema.org JSON-LD ─────────────────────────────── */

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.q,
    acceptedAnswer: { '@type': 'Answer', text: faq.a },
  })),
};

const articleJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'Tabla de Mermas de Alimentos: Porcentajes Reales por Ingrediente para Hosteleria',
  description:
    'Tabla completa de mermas de alimentos con porcentajes reales de cocina profesional: verduras, frutas, carnes, pescados y mariscos. Incluye merma de limpieza, coccion y factor de rendimiento.',
  author: { '@type': 'Organization', name: 'PLEKO' },
  publisher: {
    '@type': 'Organization',
    name: 'PLEKO',
    logo: { '@type': 'ImageObject', url: 'https://pleko.app/favicon.svg' },
  },
  datePublished: '2026-06-18',
  dateModified: '2026-06-18',
  image: 'https://pleko.app/chef-hero.jpg',
};

const breadcrumbJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'PLEKO', item: 'https://pleko.app/' },
    { '@type': 'ListItem', position: 2, name: 'Mermas en Cocina', item: 'https://pleko.app/mermas-cocina' },
    {
      '@type': 'ListItem',
      position: 3,
      name: 'Tabla de Mermas de Alimentos',
      item: 'https://pleko.app/tabla-mermas-alimentos',
    },
  ],
};

/* ─── Table Component ────────────────────────────────── */

function MermaDataTable({
  id,
  title,
  icon: Icon,
  iconColor,
  headerBg,
  data,
}: {
  id: string;
  title: string;
  icon: React.ElementType;
  iconColor: string;
  headerBg: string;
  data: string[][];
}) {
  return (
    <div id={id} className="scroll-mt-20 mb-14">
      <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4">
        <span className="flex items-center gap-3">
          <Icon className={`w-7 h-7 ${iconColor} flex-shrink-0`} />
          {title}
        </span>
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className={`${headerBg} text-white`}>
              <th className="p-3 text-left font-medium">Ingrediente</th>
              <th className="p-3 text-right font-medium">Merma limpieza</th>
              <th className="p-3 text-right font-medium">Merma coccion</th>
              <th className="p-3 text-right font-medium">Merma total</th>
              <th className="p-3 text-right font-medium">Factor rendimiento</th>
            </tr>
          </thead>
          <tbody>
            {data.map(([nombre, limpieza, coccion, total, factor], i) => {
              const totalNum = parseInt(total);
              const bgColor = totalNum >= 50 ? 'bg-red-50' : totalNum >= 30 ? 'bg-amber-50' : '';
              return (
                <tr key={nombre} className={i % 2 === 0 ? `bg-white ${bgColor}` : `bg-slate-50 ${bgColor}`}>
                  <td className="p-3 border-b border-slate-100 font-medium text-slate-800">{nombre}</td>
                  <td className="p-3 border-b border-slate-100 text-right text-slate-600">{limpieza}</td>
                  <td className="p-3 border-b border-slate-100 text-right text-slate-600">{coccion}</td>
                  <td className="p-3 border-b border-slate-100 text-right font-semibold text-emerald-700">{total}</td>
                  <td className="p-3 border-b border-slate-100 text-right font-medium text-slate-700">{factor}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ─── Main Component ─────────────────────────────────── */

export default function TablaMermasAlimentosPage() {
  return (
    <>
      <Helmet>
        <title>Tabla de Mermas de Alimentos 2026 — Porcentajes Reales por Ingrediente | PLEKO</title>
        <meta
          name="description"
          content="Tabla completa de mermas de alimentos con porcentajes reales de cocina profesional: verduras, frutas, carnes, pescados y mariscos. Merma de limpieza, coccion, factor de rendimiento y formula para calcular el precio real."
        />
        <meta
          name="keywords"
          content="tabla mermas alimentos, porcentaje merma alimentos, tabla mermas pescado, tabla mermas verduras, tabla mermas carne, merma alimentos calculo, tabla de mermas cocina, mermas alimentos hosteleria, factor de rendimiento alimentos, merma limpieza coccion"
        />
        <link rel="canonical" href="https://pleko.app/tabla-mermas-alimentos" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://pleko.app/tabla-mermas-alimentos" />
        <meta
          property="og:title"
          content="Tabla de Mermas de Alimentos 2026 — Porcentajes Reales por Ingrediente"
        />
        <meta
          property="og:description"
          content="Tabla completa de mermas de alimentos: verduras, frutas, carnes, pescados y mariscos. Con porcentajes reales de cocina profesional."
        />
        <meta property="og:image" content="https://pleko.app/chef-hero.jpg" />
        <meta property="og:locale" content="es_ES" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Tabla de Mermas de Alimentos 2026 | PLEKO"
        />
        <meta
          name="twitter:description"
          content="Porcentajes reales de merma de alimentos: verduras, frutas, carnes, pescados y mariscos. Datos de cocina profesional."
        />
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(articleJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
      </Helmet>

      <div className="bg-white">
        {/* Hero */}
        <section className="bg-gradient-to-b from-emerald-50 to-white py-16 lg:py-24">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-emerald-100 text-emerald-700 rounded-full text-sm font-medium mb-6">
                <Scissors className="w-4 h-4" />
                Tabla de mermas actualizada 2026 — datos reales de cocina profesional
              </span>
              <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight">
                Tabla de Mermas de <span className="text-emerald-600">Alimentos</span>: Porcentajes Reales por Ingrediente para Hosteleria
              </h1>
              <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
                La referencia definitiva de mermas de alimentos para cocina profesional. Mas de 80 ingredientes con porcentajes de merma de limpieza, coccion, merma total y factor de rendimiento. Datos contrastados con chefs en activo y actualizados en 2026.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="#mermas-verduras"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-600 text-white font-semibold rounded-xl hover:bg-emerald-700 transition-colors shadow-lg shadow-emerald-200"
                >
                  Ver tablas de mermas
                  <ArrowRight className="w-4 h-4" />
                </a>
                <Link
                  to="/register"
                  className="inline-flex items-center gap-2 px-6 py-3 border-2 border-slate-200 text-slate-700 font-semibold rounded-xl hover:border-slate-300 transition-colors"
                >
                  <Calculator className="w-4 h-4" />
                  Calcular mermas automaticamente
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {/* Table of Contents */}
          <nav className="bg-slate-50 border border-slate-200 rounded-xl p-6 mb-12">
            <div className="flex items-center gap-2 mb-4">
              <List className="w-5 h-5 text-emerald-600" />
              <h2 className="text-lg font-bold text-slate-900">Contenido de esta guia</h2>
            </div>
            <ol className="grid sm:grid-cols-2 gap-x-8 gap-y-2">
              {toc.map((item, i) => (
                <li key={item.id}>
                  <a href={`#${item.id}`} className="text-sm text-emerald-600 hover:text-emerald-800 hover:underline">
                    {i + 1}. {item.label}
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          {/* Section 1: Que es la merma */}
          <div id="que-es-merma" className="scroll-mt-20 mb-14">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              <span className="flex items-center gap-2">
                <Scissors className="w-7 h-7 text-emerald-600" />
                Que es la merma y por que afecta a tus costes
              </span>
            </h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-4">
              La <strong>merma de un alimento</strong> es el porcentaje de peso que se pierde entre el producto bruto (tal como lo recibes del proveedor) y el producto listo para servir al cliente. Hay dos tipos fundamentales de merma: la <strong>merma de limpieza</strong> (pelado, deshuesado, despinado, retirada de hojas exteriores, cabezas, cascaras) y la <strong>merma de coccion</strong> (perdida de agua, grasa y volumen durante el proceso termico).
            </p>
            <p className="text-slate-700 text-lg leading-relaxed mb-4">
              Ignorar las mermas es uno de los errores mas costosos en hosteleria. Si compras 1 kg de rape entero a 18 euros/kg y no contabilizas su 65% de merma (cabeza, espinas, piel), crees que tu rape cuesta 18 euros/kg cuando en realidad el producto aprovechable te esta costando <strong>51,43 euros/kg</strong>. Esa diferencia, multiplicada por cientos de platos al mes, puede significar miles de euros de perdidas invisibles.
            </p>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              Esta pagina reune las <strong>tablas de mermas mas completas</strong> que encontraras online, con datos contrastados de cocina profesional espanola. Si buscas una guia completa sobre como gestionar las mermas en tu restaurante, consulta nuestra <Link to="/mermas-cocina" className="text-emerald-600 hover:underline font-medium">guia de mermas en cocina</Link>.
            </p>

            <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 mb-6">
              <div className="flex items-start gap-3">
                <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-amber-800 mb-1">Nota importante sobre estos datos</p>
                  <p className="text-amber-900 text-sm leading-relaxed">
                    Los porcentajes de merma de esta tabla son <strong>valores orientativos</strong> basados en promedios de cocina profesional. Las mermas reales varian segun la calidad del proveedor, la temporada del producto, el tamano de las piezas y el metodo de preparacion de tu equipo de cocina. Usa estos datos como punto de partida y ajustalos con tus propias mediciones.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Section 2: Como usar esta tabla */}
          <div id="como-usar-tabla" className="scroll-mt-20 mb-14">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              <span className="flex items-center gap-2">
                <Scale className="w-7 h-7 text-emerald-600" />
                Como usar esta tabla de mermas
              </span>
            </h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              Cada tabla incluye 5 columnas clave. Asi es como debes interpretarlas:
            </p>

            <div className="space-y-4 mb-8">
              <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-5">
                <p className="font-bold text-emerald-800 mb-1">Merma de limpieza (%)</p>
                <p className="text-slate-700 text-sm leading-relaxed">
                  Porcentaje de peso que se pierde al preparar el ingrediente en crudo: pelado, retirada de semillas, deshuesado, despinado, limpieza de cascaras y partes no comestibles. Se aplica sobre el peso bruto de compra.
                </p>
              </div>
              <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-5">
                <p className="font-bold text-emerald-800 mb-1">Merma de coccion (%)</p>
                <p className="text-slate-700 text-sm leading-relaxed">
                  Porcentaje de peso que se pierde durante el proceso termico (hervir, asar, freir, etc.). Se aplica sobre el peso ya limpio. Los ingredientes que se sirven crudos tienen 0% de merma de coccion. El porcentaje varia segun el metodo de coccion — consulta la <a href="#mermas-coccion" className="text-emerald-600 hover:underline">tabla de mermas por coccion</a>.
                </p>
              </div>
              <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-5">
                <p className="font-bold text-emerald-800 mb-1">Merma total (%)</p>
                <p className="text-slate-700 text-sm leading-relaxed">
                  Combinacion de la merma de limpieza y la de coccion. Es el porcentaje total que pierdes desde la compra hasta el plato. Este es el numero que necesitas para calcular el coste real del ingrediente en tu escandallo.
                </p>
              </div>
              <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-5">
                <p className="font-bold text-emerald-800 mb-1">Factor de rendimiento</p>
                <p className="text-slate-700 text-sm leading-relaxed">
                  Multiplicador para calcular cuanto producto bruto necesitas comprar. <strong>Formula: Factor = 1 / (1 - Merma total)</strong>. Si necesitas 500 g de alcachofa lista para servir y el factor es 2,50, debes comprar 500 x 2,50 = 1.250 g de alcachofas brutas. Un factor de 1,00 significa que no hay merma; un factor de 2,86 significa que pierdes casi el 65% del producto.
                </p>
              </div>
            </div>
          </div>

          {/* ═══════════ TABLES ═══════════ */}

          <MermaDataTable
            id="mermas-verduras"
            title="Tabla completa: Mermas de verduras y hortalizas"
            icon={Leaf}
            iconColor="text-green-600"
            headerBg="bg-green-800"
            data={mermasVerduras}
          />

          <MermaDataTable
            id="mermas-frutas"
            title="Tabla completa: Mermas de frutas"
            icon={Apple}
            iconColor="text-orange-500"
            headerBg="bg-orange-700"
            data={mermasFrutas}
          />

          <MermaDataTable
            id="mermas-carnes"
            title="Tabla completa: Mermas de carnes"
            icon={Beef}
            iconColor="text-red-600"
            headerBg="bg-red-800"
            data={mermasCarnes}
          />

          <MermaDataTable
            id="mermas-pescados"
            title="Tabla completa: Mermas de pescados"
            icon={Fish}
            iconColor="text-blue-600"
            headerBg="bg-blue-800"
            data={mermasPescados}
          />

          <MermaDataTable
            id="mermas-mariscos"
            title="Tabla completa: Mermas de mariscos"
            icon={Shell}
            iconColor="text-cyan-600"
            headerBg="bg-cyan-800"
            data={mermasMariscos}
          />

          {/* Section: Precio real con merma */}
          <div id="precio-real-merma" className="scroll-mt-20 mb-14">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              <span className="flex items-center gap-2">
                <Percent className="w-7 h-7 text-emerald-600" />
                Como calcular el precio real de un ingrediente con merma
              </span>
            </h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              Conocer la merma no es suficiente — necesitas traducirla a euros para saber cuanto te cuesta realmente cada ingrediente en tu escandallo. La formula es sencilla:
            </p>

            <div className="bg-emerald-50 border-2 border-emerald-300 rounded-2xl p-8 text-center mb-8">
              <p className="text-sm text-emerald-600 font-medium uppercase tracking-wider mb-2">Formula del precio real</p>
              <p className="text-2xl sm:text-3xl font-bold text-emerald-800 font-mono">
                Precio real = Precio compra / (1 - Merma%)
              </p>
            </div>

            <h3 className="text-xl font-bold text-slate-800 mb-4">Ejemplos practicos</h3>
            <div className="overflow-x-auto mb-8">
              <table className="w-full border-collapse text-sm">
                <thead>
                  <tr className="bg-emerald-800 text-white">
                    <th className="p-3 text-left font-medium">Ingrediente</th>
                    <th className="p-3 text-right font-medium">Precio compra</th>
                    <th className="p-3 text-right font-medium">Merma total</th>
                    <th className="p-3 text-right font-medium">Precio real/kg</th>
                    <th className="p-3 text-right font-medium">Diferencia</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ['Rape entero', '18,00 euros/kg', '65%', '51,43 euros/kg', '+186%'],
                    ['Alcachofa', '4,50 euros/kg', '60%', '11,25 euros/kg', '+150%'],
                    ['Langostino', '22,00 euros/kg', '35%', '33,85 euros/kg', '+54%'],
                    ['Cordero pierna', '14,00 euros/kg', '35%', '21,54 euros/kg', '+54%'],
                    ['Brocoli', '3,20 euros/kg', '40%', '5,33 euros/kg', '+67%'],
                    ['Salmon lomo', '19,50 euros/kg', '20%', '24,38 euros/kg', '+25%'],
                    ['Champinon', '4,80 euros/kg', '13%', '5,52 euros/kg', '+15%'],
                  ].map(([ing, compra, merma, real, diff], i) => (
                    <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                      <td className="p-3 border-b border-slate-100 font-medium text-slate-800">{ing}</td>
                      <td className="p-3 border-b border-slate-100 text-right text-slate-600">{compra}</td>
                      <td className="p-3 border-b border-slate-100 text-right text-slate-600">{merma}</td>
                      <td className="p-3 border-b border-slate-100 text-right font-semibold text-emerald-700">{real}</td>
                      <td className="p-3 border-b border-slate-100 text-right font-medium text-red-600">{diff}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              Como ves, el rape entero cuesta <strong>casi 3 veces mas</strong> de lo que parece a primera vista. Si no aplicas la merma en tu <Link to="/escandallo" className="text-emerald-600 hover:underline">escandallo</Link>, estas infravalorando el coste de tus platos y potencialmente vendiendo a perdidas sin saberlo. Esta es la razon por la que muchos restaurantes no entienden por que su food cost esta por encima del objetivo.
            </p>
          </div>

          {/* Section: Mermas por coccion */}
          <div id="mermas-coccion" className="scroll-mt-20 mb-14">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              <span className="flex items-center gap-2">
                <Flame className="w-7 h-7 text-orange-500" />
                Mermas por tipo de coccion
              </span>
            </h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              La merma de coccion varia enormemente segun el metodo termico que apliques. Una misma pechuga de pollo puede perder un 15% al hacerla al vapor o un 25% si la asas en el horno a alta temperatura. Esta tabla te ayuda a estimar la perdida segun como cocines cada ingrediente.
            </p>

            <div className="overflow-x-auto mb-8">
              <table className="w-full border-collapse text-sm">
                <thead>
                  <tr className="bg-orange-700 text-white">
                    <th className="p-3 text-left font-medium">Metodo de coccion</th>
                    <th className="p-3 text-center font-medium">Perdida de peso</th>
                    <th className="p-3 text-left font-medium">Alimentos habituales</th>
                  </tr>
                </thead>
                <tbody>
                  {mermasCoccion.map(([metodo, perdida, alimentos], i) => (
                    <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                      <td className="p-3 border-b border-slate-100 font-medium text-slate-800">{metodo}</td>
                      <td className="p-3 border-b border-slate-100 text-center font-semibold text-orange-600">{perdida}</td>
                      <td className="p-3 border-b border-slate-100 text-slate-600">{alimentos}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
              <div className="flex items-start gap-3">
                <Lightbulb className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-blue-800 mb-1">Sous vide: la coccion con menor merma</p>
                  <p className="text-blue-700 text-sm leading-relaxed">
                    La coccion sous vide (al vacio a baja temperatura) es la que menos merma produce: entre un 3% y un 8%. Al cocinar en una bolsa sellada, el alimento retiene practicamente toda su humedad y jugos. Para ingredientes premium con alto precio por kilo (solomillo, lomo de bacalao, foie), cocinar sous vide no solo mejora la textura sino que reduce la perdida de producto, bajando el coste real.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Section: Reducir mermas */}
          <div id="reducir-mermas" className="scroll-mt-20 mb-14">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              <span className="flex items-center gap-2">
                <Lightbulb className="w-7 h-7 text-amber-500" />
                Como reducir mermas en tu cocina
              </span>
            </h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              Reducir las mermas no significa servir menos cantidad al cliente. Significa <strong>aprovechar mejor el producto que compras</strong>. Aqui van 7 estrategias probadas en cocinas profesionales:
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-200">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-500 text-white font-bold flex items-center justify-center text-sm">1</span>
                <div>
                  <p className="font-semibold text-slate-800 mb-1">Compra producto semielaborado cuando la merma sea alta</p>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Si la alcachofa tiene un 60% de merma y tu proveedor vende corazones de alcachofa limpios al doble de precio, haz numeros: el producto limpio puede salir mas barato que el bruto despues de aplicar la merma. Lo mismo con rape en lomos vs. rape entero, o langostinos pelados vs. enteros.
                  </p>
                </div>
              </div>
              <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-200">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-500 text-white font-bold flex items-center justify-center text-sm">2</span>
                <div>
                  <p className="font-semibold text-slate-800 mb-1">Aprovecha los recortes y subproductos</p>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Las espinas y cabezas de pescado sirven para fondos y fumets. Los recortes de carne para caldos y guisos. Las hojas exteriores de verduras para cremas. Los tallos de brocoli para purees. Convierte la merma en una elaboracion base que reduzca el coste de otras recetas.
                  </p>
                </div>
              </div>
              <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-200">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-500 text-white font-bold flex items-center justify-center text-sm">3</span>
                <div>
                  <p className="font-semibold text-slate-800 mb-1">Forma a tu equipo en tecnicas de corte y limpieza</p>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    La diferencia entre un cocinero experimentado y uno novato al limpiar un pescado puede ser de un 5-10% de merma adicional. Invierte en formacion: que todo el equipo aprenda a pelar patatas dejando la minima piel, a despinar pescado sin llevarse carne, y a deshuesar pollo con precision.
                  </p>
                </div>
              </div>
              <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-200">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-500 text-white font-bold flex items-center justify-center text-sm">4</span>
                <div>
                  <p className="font-semibold text-slate-800 mb-1">Controla la temperatura y el tiempo de coccion</p>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Un filete de ternera que pasa 2 minutos de mas en la plancha pierde un 5-8% mas de peso. El control preciso de temperaturas y tiempos (especialmente con sous vide y hornos de conveccion programables) reduce la merma de coccion de forma significativa. Estandariza tiempos y temperaturas para cada elaboracion.
                  </p>
                </div>
              </div>
              <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-200">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-500 text-white font-bold flex items-center justify-center text-sm">5</span>
                <div>
                  <p className="font-semibold text-slate-800 mb-1">Pide calibres adecuados a tu proveedor</p>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Las piezas mas grandes suelen tener menor proporcion de merma que las pequenas (la relacion piel/carne es mejor en una patata grande que en una pequena). Negocia con tu proveedor calibres que se adapten a tus preparaciones para minimizar la merma.
                  </p>
                </div>
              </div>
              <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-200">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-500 text-white font-bold flex items-center justify-center text-sm">6</span>
                <div>
                  <p className="font-semibold text-slate-800 mb-1">Mide y registra tus mermas reales</p>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    Lo que no se mide no se puede mejorar. Pesa los ingredientes antes y despues de la manipulacion durante al menos una semana al mes. Con PLEKO puedes registrar la merma real de cada ingrediente y el sistema la aplica automaticamente a todos los escandallos donde se use.
                  </p>
                </div>
              </div>
              <div className="flex gap-4 p-5 bg-slate-50 rounded-xl border border-slate-200">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-500 text-white font-bold flex items-center justify-center text-sm">7</span>
                <div>
                  <p className="font-semibold text-slate-800 mb-1">Adapta tu carta a la temporada</p>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    El producto de temporada tiene mejor calidad y menor merma que el producto fuera de temporada (piel mas fina, menos deterioro, piezas mas uniformes). Consulta el <Link to="/calendario-temporada" className="text-emerald-600 hover:underline">calendario de temporada</Link> y ajusta tu carta para trabajar con producto en su punto optimo.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Section: Software vs Excel */}
          <div id="software-vs-excel" className="scroll-mt-20 mb-14">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              <span className="flex items-center gap-2">
                <Calculator className="w-7 h-7 text-blue-600" />
                Software vs Excel para controlar mermas
              </span>
            </h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              Puedes copiar estos porcentajes a una hoja de Excel y aplicarlos manualmente a cada escandallo. Funciona... hasta que tienes 30 recetas y 150 ingredientes. El problema del Excel es que cada cambio de merma requiere actualizar manualmente todas las recetas donde se usa ese ingrediente.
            </p>

            <div className="overflow-x-auto mb-8">
              <table className="w-full border-collapse text-sm">
                <thead>
                  <tr className="bg-slate-800 text-white">
                    <th className="p-3 text-left font-medium">Aspecto</th>
                    <th className="p-3 text-center font-medium">Excel / Hoja de calculo</th>
                    <th className="p-3 text-center font-medium">PLEKO Software</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ['Registrar merma por ingrediente', 'Manual en cada celda', 'Una vez, se aplica a todas las recetas'],
                    ['Actualizar merma despues de medir', 'Buscar y cambiar en cada archivo', 'Un cambio recalcula todo'],
                    ['Calcular precio real con merma', 'Formula manual por ingrediente', 'Automatico en tiempo real'],
                    ['Factor de rendimiento', 'Calculo manual', 'Mostrado automaticamente'],
                    ['Merma de limpieza + coccion', 'Dos columnas separadas', 'Configurable por tipo de preparacion'],
                    ['Alerta si la merma sube el food cost', 'No disponible', 'Semaforo automatico'],
                    ['Equipo de cocina (varios usuarios)', 'Dificil de compartir', 'Acceso por roles en tiempo real'],
                  ].map(([aspecto, excel, pleko], i) => (
                    <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                      <td className="p-3 border-b border-slate-100 font-medium text-slate-800">{aspecto}</td>
                      <td className="p-3 border-b border-slate-100 text-center text-slate-600">{excel}</td>
                      <td className="p-3 border-b border-slate-100 text-center font-medium text-blue-700">{pleko}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="text-slate-700 text-lg leading-relaxed">
              Si estas empezando, descarga nuestra <Link to="/plantilla-escandallo-excel" className="text-emerald-600 hover:underline">plantilla de escandallo en Excel</Link> y usa los porcentajes de esta tabla. Cuando tu carta crezca y gestionar mermas manualmente se vuelva insostenible, <Link to="/register" className="text-emerald-600 hover:underline">prueba PLEKO gratis 14 dias</Link> y automatiza todo el proceso.
            </p>
          </div>

          {/* Mid-page CTA */}
          <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-2xl p-8 text-center text-white mb-16">
            <Scissors className="w-10 h-10 mx-auto mb-4 opacity-90" />
            <h2 className="text-2xl font-bold mb-3">Calcula mermas automaticamente con PLEKO</h2>
            <p className="text-emerald-100 mb-6 max-w-xl mx-auto">
              PLEKO aplica la merma de cada ingrediente automaticamente a todas tus recetas. Cuando cambias una merma, todos los escandallos y food costs se recalculan al instante. Sin hojas de calculo, sin errores manuales.
            </p>
            <Link
              to="/register"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white text-emerald-700 font-bold rounded-xl hover:bg-emerald-50 transition-colors"
            >
              Empezar gratis — 14 dias sin tarjeta
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* FAQ */}
          <div id="faqs" className="mt-16 scroll-mt-20">
            <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">Preguntas frecuentes sobre mermas de alimentos</h2>
            <div className="space-y-4">
              {faqs.map(({ q, a }) => (
                <details key={q} className="border border-slate-200 rounded-xl overflow-hidden">
                  <summary className="p-5 font-semibold text-slate-800 cursor-pointer hover:bg-slate-50 flex justify-between items-center list-none">
                    {q}
                    <span className="text-slate-400 text-xl ml-4">+</span>
                  </summary>
                  <div className="px-5 pb-5 text-slate-600 leading-relaxed border-t border-slate-100 pt-4">{a}</div>
                </details>
              ))}
            </div>
          </div>

          {/* Internal links */}
          <div className="mt-12 p-6 bg-slate-50 rounded-xl border border-slate-200">
            <h3 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-emerald-600" /> Guias relacionadas
            </h3>
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                { to: '/escandallo', label: 'Que es un escandallo: guia completa' },
                { to: '/mermas-cocina', label: 'Mermas en cocina: guia completa' },
                { to: '/como-hacer-escandallo', label: 'Como hacer un escandallo paso a paso' },
                { to: '/ejemplo-escandallo', label: '8 ejemplos de escandallo reales' },
                { to: '/calculadora-escandallo', label: 'Calculadora de escandallo online gratis' },
                { to: '/software-escandallo', label: 'Software de escandallo para restaurantes' },
                { to: '/food-cost', label: 'Food cost: que es y como calcularlo' },
                { to: '/desperdicio-alimentario-restaurante', label: 'Desperdicio alimentario en restaurantes' },
              ].map(({ to, label }) => (
                <Link key={to} to={to} className="flex items-center gap-2 text-sm text-emerald-600 hover:text-emerald-800 hover:underline">
                  <ArrowRight className="w-3 h-3" /> {label}
                </Link>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div className="mt-16 bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-2xl p-8 text-center text-white">
            <Scale className="w-12 h-12 mx-auto mb-4 opacity-90" />
            <h2 className="text-2xl font-bold mb-3">Controla las mermas de toda tu carta con PLEKO</h2>
            <p className="text-emerald-100 mb-6 max-w-xl mx-auto">
              Deja de copiar porcentajes en hojas de calculo. PLEKO registra la merma de cada ingrediente, calcula el precio real automaticamente, y te avisa cuando el food cost se dispara. Prueba gratis 14 dias.
            </p>
            <Link
              to="/register"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white text-emerald-700 font-bold rounded-xl hover:bg-emerald-50 transition-colors"
            >
              Empezar gratis — 14 dias sin tarjeta
              <ArrowRight className="w-4 h-4" />
            </Link>
            <p className="mt-3 text-emerald-200 text-sm">Sin tarjeta de credito. Configurado en 2 minutos.</p>
          </div>
        </section>
      </div>
    </>
  );
}
